import { getApiUrl, getAuthHeaders } from './api-client';

/**
 * POST /admin/uploads
 * Загрузить файл, фото или видео
 */
export async function uploadFile(file, kind = 'image', uploadPath) {
    try {
        const apiUrl = getApiUrl();
        if (!apiUrl) {
            throw new Error('API URL is not configured');
        }

        const formData = new FormData();
        formData.append('file', file);
        if (kind) {
            formData.append('kind', kind);
        }
        if (uploadPath) {
            formData.append('uploadPath', uploadPath);
        }

        const url = `${apiUrl}/admin/uploads`;

        const response = await fetch(url, {
            method: 'POST',
            headers: { ...getAuthHeaders() },
            body: formData,
        });

        const data = await response.json();


        if (!response.ok) {
            const errorMsg = data?.message || `Failed to upload file. Status: ${response.status}`;
            console.error('Upload error:', errorMsg, data);
            throw new Error(errorMsg);
        }

        return data;
    } catch (error) {
        console.error("Error uploading file:", error);
        throw error;
    }
}

export async function uploadImage(file, uploadPath) {
    return uploadFile(file, 'image', uploadPath);
}

export async function uploadVideo(file, uploadPath) {
    return uploadFile(file, 'video', uploadPath);
}

// Alias для совместимости с существующим кодом
export const uploadAdminImages = uploadImage;
